
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(12|23|64|8)|215|680|888)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
